import { grey400 } from 'material-ui/styles/colors';

const styles = {
    toggle: {
        marginBottom: '10px'
    },
    helperText: {
        fontSize: 16,
        color: grey400
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/common/GamificationSetting/GamificationSetting.css.js